import axios from "../plugins/parseAxios";

export class BookingAPI {
  static createBooking(formData) {
    return axios.post("functions/createBooking", formData);
  }
  static editBooking(formData) {
    return axios.post("functions/editBooking", formData);
  }
  static getBookingByArea(areaId) {
    return axios.post("functions/getBookingByArea", {
      areaId
    });
  }
  static getBookingByAreaCustomer(payload) {
    return axios.post("functions/getBookingByAreaCustomer", payload);
  }
  static getBooking(bookingId) {
    return axios.post("functions/getBooking", {
      id: bookingId
    });
  }
  static cancelBooking(bookingId) {
    return axios.post("functions/cancelBooking", {
      id: bookingId
    });
  }
  static checkInMonthlyBooking(bookingId) {
    return axios.post("functions/checkInMonthlyBooking", {
      id: bookingId
    });
  }
  static checkInMonthlyBookingFirst(bookingId) {
    return axios.post("functions/checkInMonthlyBookingFirst", {
      id: bookingId
    });
  }
  static getBookingBetweenDateByMarket(formData) {
    return axios.post("functions/getBookingBetweenDateByMarket", formData);
  }
  static getBookingBetweenDateByProject(formData) {
    return axios.post("functions/getBookingBetweenDateByProject", formData);
  }
  static getBookingCheckinToday(formData) {
    return axios.post("functions/getBookingCheckinToday", formData);
  }
  static getBookingByCustomerLimit(payload) {
    return axios.post("functions/getBookingByCustomerLimit", payload);
  }
}